import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import React, { createContext, useState } from "react";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 999999,
    color: "#fff",
  },
}));

export const AdminModalLoadingContext = createContext({
  isOpen: false,
  showAdminLoading: () => { },
  hideAdminLoading: () => { },
});

function AdminModalLoadingProvider({ children }) {
  const classes = useStyles();

  const [isOpen, setOpen] = useState(false);
  const showAdminLoading = () => {
    setOpen(true);
  };
  const hideAdminLoading = () => {
    setOpen(false);
  };

  return (
    <AdminModalLoadingContext.Provider
      value={{
        isOpen,
        showAdminLoading,
        hideAdminLoading,
      }}
    >
      {children}
      <Backdrop className={classes.backdrop} open={isOpen} id="loading">
        <CircularProgress color="inherit" />
      </Backdrop>
    </AdminModalLoadingContext.Provider>
  );
}

export default AdminModalLoadingProvider;
